import styled from 'styled-components'

export const Layout = styled.div`
  position: relative;
  padding: 1.5rem 1rem;
  width: 100%;
  flex: 1;

  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 1rem;

  border-radius: 8px;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
`

export const LabelResultsContainer = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: minmax(100px, 178px) minmax(calc(91px * 4), 1.5fr) minmax(107px, 0.5fr);
  gap: 0.5rem;
`

export const CompensateGridContainer = styled.div``

export const YearsResults = styled.div`
  position: relative;
  width: 100%;
  display: grid;
  direction: rtl;
  grid-template-columns: repeat(4, minmax(91px, 1fr));
`

export const LabelResults = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  color: ${props => props.theme.colors.color545e6c};
`

export const HorizontalDivisor = styled.div`
  position: relative;
  background: ${props => props.theme.colors.colorDCE3ED};
  height: 1px;
  width: 100%;
`
